import rslnLogo from "@SeemplicityDev/shared/src/design-system/assets/logos/resillion-logo-white.png";
import Logo from "@SeemplicityDev/shared/src/design-system/assets/logos/logo-white.svg";
import type { AppStyleLogo } from "./useAppStyling";

export const defaultLogos: AppStyleLogo = { login: Logo, app: Logo };
export const appStyleLogos: Record<string, AppStyleLogo> = {
  "5a5943c78786cc17eb1a42ee754df2c96e5ec6dbe2af1d19bf26d439bb7d02b9": {
    login: rslnLogo,
    app: rslnLogo,
  },
  // Resillion UK hash
  b395aa501cb76c6899a2ab36cc6278d855fdd9c6c8532b8bd5bf7b08d6912acf: {
    login: rslnLogo,
    app: rslnLogo,
  },
};
